export default __webpack_public_path__ + "static/media/OpenSans-Light.d47c5091.woff";